import * as React from 'react';
import { connect } from 'react-redux';
import { reduxForm, initialize } from 'redux-form';
import { Card } from 'material-ui/Card';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { isEqual } from 'lodash';
import { compose, withProps, withHandlers, withState } from 'recompose';

import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { entityDetailEnhancer } from '@components/hoc/entityDetailEnhancer';

import { Tabs } from '@components/tabs';
import { withConfiguration } from '@components/hoc/withConfiguration';
import { setSettings } from '@components/provider/configuration/_configurationActions';

import * as T from '@modules/generalSettings/_generalSettingsTypes';

import GeneralSettingsFormOthers from '@modules/generalSettings/GeneralSettingsFormOthers';
import GeneralSettingsFormNumberSequence from '@modules/generalSettings/GeneralSettingsFormNumberSequences';
import { Prompt } from 'react-router';
import { getGeneralSettings, postGeneralSettings } from '@modules/generalSettings/_generalSettingsActions';

const enhance = compose<T.GeneralSettingsFormProps, T.GeneralSettingsFormProps>(
  breadcrumbs([{ label: 'Nastavení' }]),
  connect(),
  withProps({ item: '038605bb-e9ec-4181-91c2-4fa3fa732b71' }),
  entityDetailEnhancer({
    getEntity: getGeneralSettings,
    defaultEntity: {}
  }),
  withProps(({ entity }) => {
    return { initialValues: entity };
  }),
  withState('editable', 'setEditable', false),
  withConfiguration({ setSettings }),
  withHandlers({
    onSubmit: ({ dispatch, setEditable, initialValues: { otherSettings }, setSettingsConfig }) => async formData => {
      const response = await postGeneralSettings(formData);

      if (response) {
        dispatch(initialize('module-general-settings', response));
        setEditable(false);
        if (!isEqual(otherSettings, response.otherSettings)) {
          setSettingsConfig(response.otherSettings);
        }
      }
    },
    handleCancel: ({ dispatch, initialValues, setEditable }) => () => {
      dispatch(initialize('module-general-settings', initialValues));
      setEditable(false);
    }
  }),
  reduxForm({
    form: 'module-general-settings'
  })
);

const View: React.SFC<T.GeneralSettingsFormProps> = ({
  change,
  dirty,
  submitSucceeded,
  submitting,
  handleSubmit,
  handleCancel,
  setEditable,
  editable
}) => (
  <div>
    <Prompt when={dirty && !submitSucceeded && !submitting} message="Vaše změny nebyly uloženy, přesto odejít?" />
    <form className="layout" onSubmit={handleSubmit}>
      <Card>
        <Tabs
          items={[
            {
              label: 'Číselníky',
              style: { minWidth: 175 },
              content: <GeneralSettingsFormNumberSequence editable={editable} />
            },
            {
              label: 'Další',
              style: { minWidth: 175 },
              content: <GeneralSettingsFormOthers change={change} editable={editable} />
            }
          ]}
        />

        {editable ? (
          <div>
            <Button type="submit" label="Uložit a zavřít" primary={true} style={{ margin: '16px 0 16px 16px' }} />
            <Button label="Zrušiť" style={{ margin: '16px 0 16px 16px' }} onClick={handleCancel} />
          </div>
        ) : (
          <Button
            label="Upravit"
            primary={true}
            style={{ margin: '16px 0 16px 16px' }}
            onClick={() => setEditable(true)}
          />
        )}
      </Card>
    </form>
  </div>
);

export const GeneralSettingsForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/generalSettings/GeneralSettingsForm.tsx